// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__IAWvG","right":"styles_right__2-KFL"};